import { render, staticRenderFns } from "./merchants.vue?vue&type=template&id=564f68fa&scoped=true&"
import script from "./merchants.vue?vue&type=script&lang=js&"
export * from "./merchants.vue?vue&type=script&lang=js&"
import style0 from "./merchants.vue?vue&type=style&index=0&id=564f68fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f68fa",
  null
  
)

export default component.exports